import OperationsController from "../adapters/opentrip.controller";

const getPassengers = async(payload) =>{
    const response = await OperationsController.getPassengers(payload)
    return response;
}


export default getPassengers;